import * as LaunchDarkly from 'launchdarkly-js-client-sdk'
import { get } from 'svelte/store'
import { user, emulateUser } from 'stores/auth'

let launchDarklyClient = null
let initializationPromise = null

function buildContext(activeUser, emulatedUser) {
  const email = emulatedUser?.email || activeUser?.email
  const key = email || emulatedUser?.sub || activeUser?.sub || 'anonymous'

  return email ? { key, email } : { key }
}

async function waitForAuthentication() {
  return new Promise(resolve => {
    const currentUser = get(user)

    if (currentUser) {
      resolve(currentUser)
      return
    }

    const unsubscribe = user.subscribe(userData => {
      if (userData) {
        unsubscribe()
        resolve(userData)
      }
    })
  })
}

async function initialize() {
  await waitForAuthentication()

  const currentUser = get(user)
  const currentEmulatedUser = get(emulateUser)

  const context = buildContext(currentUser, currentEmulatedUser)

  const client = LaunchDarkly.initialize(import.meta.env.VITE_LAUNCHDARKLY_ENV_KEY, context)
  await client.waitForInitialization()

  let previousEmulatedEmail = currentEmulatedUser?.email || null

  emulateUser.subscribe(async emulatedUser => {
    if (!client) return

    const currentEmulatedEmail = emulatedUser?.email || null

    if (currentEmulatedEmail === previousEmulatedEmail) return

    previousEmulatedEmail = currentEmulatedEmail

    const activeUser = get(user)
    const newContext = buildContext(activeUser, emulatedUser)

    await client.identify(newContext)
  })

  return client
}

async function getClient() {
  if (launchDarklyClient) {
    return launchDarklyClient
  }

  if (!initializationPromise) {
    initializationPromise = initialize()
  }

  launchDarklyClient = await initializationPromise
  return launchDarklyClient
}

export async function getFlagValue(key, fnChangeListener) {
  const client = await getClient()
  const flagValue = await client.variation(key, false)

  if (fnChangeListener) {
    client.on(`change:${key}`, fnChangeListener)
  }
  return flagValue
}

export async function getFlagWithListener(key, fnChangeListener) {
  const client = await getClient()
  let flagValue = await client.variation(key, false)

  client.on(`change:${key}`, newVal => {
    flagValue = newVal
    if (fnChangeListener) {
      fnChangeListener(newVal)
    }
  })

  return flagValue
}
